import Swatch from './Swatch.view';

export default Swatch;
